import { ToolkitProperty, ToolkitPropertyRowMap } from '@aloft/toolkit-shared';

import { systemAccessorTPColumnDefs } from '../systemAccessorTPColumnDefs.js';
import {
  SystemAccessorTPColumnKey,
  TPColumnKey,
  TPTableSelector,
  isSystemAccessorTPColumnKey,
  isTPColumnKey,
} from '../types.ts';

export function getTPSelector(
  column: TPColumnKey | SystemAccessorTPColumnKey,
): TPTableSelector<ToolkitProperty, unknown> {
  if (isSystemAccessorTPColumnKey(column)) {
    return systemAccessorTPColumnDefs[column].selector;
  }
  if (isTPColumnKey(column)) {
    const info = ToolkitPropertyRowMap[column];
    return info.type === 'address'
      ? (p) => p.address // TODO: Address lens?
      : (p) =>
          p[info.valueProps.annotator?.valueKey as keyof ToolkitProperty] ??
          (() => console.error(`Could not get column: ${column}`));
  }

  console.error(`Invalid column '${column}'.`);
  return () => undefined;
}
